/* Language switch: keep the visitor on the same page, including the hash (info page panels). */
(function () {
  document.querySelectorAll('form[action*="localization"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var field = form.querySelector('input[name="return_to"]');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'return_to';
        form.appendChild(field);
      }
      field.value = window.location.pathname + window.location.search + window.location.hash;
    });
  });
})();
